import { render } from "./TeamRemoveDialog.vue?vue&type=template&id=9f451c0a"
import script from "./TeamRemoveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRemoveDialog.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Team/TeamRemoveDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f451c0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f451c0a', __exports__)) {
    api.reload('9f451c0a', __exports__)
  }
  
  module.hot.accept("./TeamRemoveDialog.vue?vue&type=template&id=9f451c0a", () => {
    api.rerender('9f451c0a', render)
  })

}


export default __exports__